import React, { useState, useEffect } from 'react';

import { Tooltip, Fab } from "@mui/material";
import Grid from '@mui/material/Grid2';
import {
  DeleteForever
} from "@mui/icons-material";

import { 
  ARMOR_TYPE_OPTIONS,
  StartEquipmentItem,
  WEAPON_KEYWORD_OPTIONS, 
} from "@dndModels";
import { 
  ITEM_TYPES
} from "@dndModels/Constants";

import StringBox from "@components/input/strings/StringBox";
import SelectStringBox from "@components/input/selects/SelectStringBox";
import SelectObjectBox from "@components/input/selects/SelectObjectBoxSimple";

interface Props {
  item: StartEquipmentItem;
  onChange: (item: StartEquipmentItem) => void;
  onDelete: () => void; 
  disabled: boolean;
}

export default function StartEquipmentItemInput({ 
  item,
  onChange,
  onDelete,
  disabled,
}: Props) {
  const [my_item, setItem] = useState(item.clone());
  const [reloading, setReloading] = useState(false);

  useEffect(() => {
    if (reloading) {
      setReloading(false);
    }
  }, [reloading, setReloading]);

  return (
    <Grid container spacing={0} direction="row">
      <Grid size={1}>
        { !disabled &&
          <Tooltip title={`Remove Item`}>
            <Fab size="small" color="primary" style={{marginLeft: "8px"}}
              onClick={ () => {
                onDelete();
              }}>
              <DeleteForever/>
            </Fab>
          </Tooltip>
        }
      </Grid>
      <Grid size={2}>
        <SelectStringBox 
          name="Item Type"
          options={["Item","Type","Pack","Money","Other Item"]}
          value={my_item.item_type}
          disabled={ disabled }
          onChange={(changed: "Item" | "Type" | "Pack" | "Money" | "Other Item") => {
            const new_item = my_item;
            new_item.item_type = changed;
            if (changed === "Money") {
              new_item.item = "Gold";
            }
            setItem(new_item);
            onChange(new_item);
          }}
        />
      </Grid>
      { my_item.item_type === "Item" ?
        <Grid size={6}>
          <SelectObjectBox
            name="Item"
            data_type="item"
            // internal_filter
            auto_sort
            value={my_item.item}
            disabled={ disabled }
            onChange={(changed: string) => {
              const new_item = my_item;
              new_item.item = changed;
              setItem(new_item);
              onChange(new_item);
            }}
          />
        </Grid>
      : my_item.item_type === "Type" ?
        <Grid
          size={{
            xs: my_item.item === "Weapon" || my_item.item === "Armor" ? 6 : 9
          }}>
          <SelectStringBox 
            name="Type"
            options={ITEM_TYPES}
            value={my_item.item}
            disabled={ disabled }
            onChange={(changed: string) => {
              const new_item = my_item;
              new_item.item = changed;
              setItem(new_item);
              onChange(new_item);
            }}
          />
        </Grid>
      : my_item.item_type === "Pack" ?
        <Grid size={9}>
          <SelectObjectBox
            name="Pack"
            data_type="equipment_pack"
            value={my_item.item}
            disabled={ disabled }
            onChange={(changed: string) => {
              const new_item = my_item;
              new_item.item = changed;
              setItem(new_item);
              onChange(new_item);
            }}
          />
        </Grid>
      : my_item.item_type === "Money" ?
        <Grid size={9}
          container spacing={0} direction="row">
          <Grid size={6}>
            <SelectStringBox 
              name="Type"
              options={["Platinum","Gold","Electrum","Silver","Copper"]}
              value={my_item.item}
              disabled={ disabled }
              onChange={(changed: string) => {
                const new_item = my_item;
                new_item.item = changed;
                setItem(new_item);
                onChange(new_item);
              }}
            />
          </Grid>
          <Grid size={6}>
            <StringBox 
              name="Quantity"
              value={my_item.item_count}
              type="number"
              disabled={ disabled }
              onBlur={(changed: string) => {
                const new_item = my_item;
                new_item.item_count = +changed;
                setItem(new_item);
                onChange(new_item);
              }}
            />
          </Grid>
        </Grid>
      : 
        <Grid size={9}>
          <StringBox 
            name="Other Item"
            value={my_item.item}
            disabled={ disabled }
            onBlur={(changed: string) => {
              const new_item = my_item;
              new_item.item = changed;
              setItem(new_item);
              onChange(new_item);
            }}
          />
        </Grid>
      }
      { my_item.item_type === "Item" &&
        <Grid size={3}>
          <StringBox 
            name="Count"
            value={my_item.item_count}
            disabled={ disabled }
            type="number"
            onBlur={(changed: string) => {
              const new_item = my_item;
              new_item.item_count = +changed;
              setItem(new_item);
              onChange(new_item);
            }}
          />
        </Grid>
      }
      { my_item.item_type === "Type" && my_item.item === "Weapon" &&
        <Grid size={3}>
          <SelectStringBox
            name="Weapon Type"
            options={WEAPON_KEYWORD_OPTIONS}
            value={my_item.detail}
            disabled={ disabled }
            onChange={(changed: string) => {
              const new_item = my_item;
              new_item.detail = changed;
              setItem(new_item);
              onChange(new_item);
            }}
          />
        </Grid>
      }
      { my_item.item_type === "Type" && my_item.item === "Armor" &&
        <Grid size={3}>
          <SelectStringBox
            name="Armor Type"
            options={ARMOR_TYPE_OPTIONS}
            value={my_item.detail}
            disabled={ disabled }
            onChange={(changed: string) => {
              const new_item = my_item;
              new_item.detail = changed;
              setItem(new_item);
              onChange(new_item);
            }}
          />
        </Grid>
      }
    </Grid>
  );
}
